import { render } from "./ButtonMaster.vue?vue&type=template&id=ec552b5e"
import script from "./ButtonMaster.vue?vue&type=script&lang=js"
export * from "./ButtonMaster.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__